import React, { forwardRef } from "react";

export interface ProgramTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  fullWidth?: boolean;
  containerClassName?: string;
}

const ProgramTextarea = forwardRef<HTMLTextAreaElement, ProgramTextareaProps>(
  (
    {
      label,
      error,
      fullWidth = true,
      containerClassName = "",
      className = "",
      rows = 4,
      id,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`mb-4 ${
          fullWidth ? "w-full" : "w-full md:w-1/2"
        } pr-4 ${containerClassName}`}
      >
        <label className="block text-[#607D8B] text-sm mb-2" htmlFor={id}>
          {label}
        </label>
        <textarea
          id={id}
          ref={ref}
          rows={rows}
          className={`resize-none border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium rounded-[8px] px-3 py-2 transition-colors ${
            error ? "border-red-400 bg-red-50/40" : "border-[#E0E4EC]"
          } ${className}`}
          {...props}
        />
        {error && (
          <p className="text-xs text-red-500 mt-1 font-gilroy-medium">
            {error}
          </p>
        )}
      </div>
    );
  }
);

ProgramTextarea.displayName = "ProgramTextarea";

export default ProgramTextarea;
